export const MAX_TIME_EXPIRATION = 60 * 60 * 1000; // 60min